import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const PersonalInfoForm = ({ initialData, onSave, className = '' }) => {
  const [formData, setFormData] = useState({
    firstName: initialData?.firstName || '',
    lastName: initialData?.lastName || '',
    email: initialData?.email || '',
    phone: initialData?.phone || '',
    nationalId: initialData?.nationalId || '',
    birthDate: initialData?.birthDate || '',
    address: initialData?.address || '',
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Clear error when user starts typing
    if (errors?.[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: '',
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.firstName?.trim()) {
      newErrors.firstName = 'نام الزامی است';
    }

    if (!formData?.lastName?.trim()) {
      newErrors.lastName = 'نام خانوادگی الزامی است';
    }

    if (!formData?.email?.trim()) {
      newErrors.email = 'ایمیل الزامی است';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(formData?.email)) {
      newErrors.email = 'فرمت ایمیل صحیح نیست';
    }

    if (!formData?.phone?.trim()) {
      newErrors.phone = 'شماره تلفن الزامی است';
    } else if (formData?.phone?.length < 11) {
      newErrors.phone = 'شماره تلفن باید ۱۱ رقم باشد';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();

    if (!validateForm()) return;

    setIsLoading(true);

    try {
      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 1500));
      onSave?.(formData);
    } catch (error) {
      console.error('Error saving profile:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className={`space-y-6 ${className}`}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="نام"
          type="text"
          value={formData?.firstName}
          onChange={(e) => handleInputChange('firstName', e?.target?.value)}
          error={errors?.firstName}
          required
          placeholder="نام خود را وارد کنید"
        />

        <Input
          label="نام خانوادگی"
          type="text"
          value={formData?.lastName}
          onChange={(e) => handleInputChange('lastName', e?.target?.value)}
          error={errors?.lastName}
          required
          placeholder="نام خانوادگی خود را وارد کنید"
        />
      </div>
      <Input
        label="آدرس ایمیل"
        type="email"
        value={formData?.email}
        onChange={(e) => handleInputChange('email', e?.target?.value)}
        error={errors?.email}
        required
        placeholder="example@email.com"
        description="ایمیل برای ورود به حساب کاربری استفاده می‌شود"
      />
      <Input
        label="شماره تلفن همراه"
        type="tel"
        value={formData?.phone}
        onChange={(e) => handleInputChange('phone', e?.target?.value)}
        error={errors?.phone}
        required
        placeholder="۰۹۱۲۳۴۵۶۷۸۹"
        description="شماره تلفن برای تأیید هویت استفاده می‌شود"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="کد ملی"
          type="text"
          value={formData?.nationalId}
          onChange={(e) => handleInputChange('nationalId', e?.target?.value)}
          error={errors?.nationalId}
          placeholder="۱۲۳۴۵۶۷۸۹۰"
        />

        <Input
          label="تاریخ تولد"
          type="text"
          value={formData?.birthDate}
          onChange={(e) => handleInputChange('birthDate', e?.target?.value)}
          error={errors?.birthDate}
          placeholder="۱۳۶۰/۰۵/۱۵"
        />
      </div>
      <Input
        label="آدرس"
        type="text"
        value={formData?.address}
        onChange={(e) => handleInputChange('address', e?.target?.value)}
        error={errors?.address}
        placeholder="آدرس کامل خود را وارد کنید"
      />
      <div className="flex justify-end gap-4 pt-4">
        <Button type="button" variant="outline" disabled={isLoading}>
          انصراف
        </Button>

        <Button
          type="submit"
          loading={isLoading}
          iconName="Save"
          iconPosition="right">
          ذخیره تغییرات
        </Button>
      </div>
    </form>
  );
};

export default PersonalInfoForm;
